import { US_MAJOR_SCOPE } from "../utils/nflLeagueScope";

export const NFL_ALL_TIME_GREATS_DEFAULT = {
  stat: "passing-yards",
};

export const NFL_ALL_TIME_GREATS_STATS = {
  "passing-yards": {
    key: "passing-yards",
    label: "Passing Yards",
    railLabel: "PASS YDS",
    statField: "passingYards",
  },
  "passing-tds": {
    key: "passing-tds",
    label: "Passing TDs",
    railLabel: "PASS TD",
    statField: "passingTds",
  },
  "rushing-yards": {
    key: "rushing-yards",
    label: "Rushing Yards",
    railLabel: "RUSH YDS",
    statField: "rushingYards",
  },
  "rushing-tds": {
    key: "rushing-tds",
    label: "Rushing TDs",
    railLabel: "RUSH TD",
    statField: "rushingTds",
  },
  "receiving-yards": {
    key: "receiving-yards",
    label: "Receiving Yards",
    railLabel: "REC YDS",
    statField: "receivingYards",
  },
  "receiving-tds": {
    key: "receiving-tds",
    label: "Receiving TDs",
    railLabel: "REC TD",
    statField: "receivingTds",
  },
  receptions: {
    key: "receptions",
    label: "Receptions",
    railLabel: "REC",
    statField: "receptions",
  },
};

export const NFL_TOP_PLAYER_CATEGORIES = [
  "passing-yards",
  "rushing-yards",
  "receiving-yards",
  "passing-tds",
];

export const getNflAllTimeGreatsStat = (statKey) =>
  NFL_ALL_TIME_GREATS_STATS[statKey] ||
  NFL_ALL_TIME_GREATS_STATS[NFL_ALL_TIME_GREATS_DEFAULT.stat];

export const buildNflAllTimeGreatsPath = ({
  stat = NFL_ALL_TIME_GREATS_DEFAULT.stat,
  page = 1,
  pageSize = 25,
  leagueScope,
} = {}) => {
  const config = getNflAllTimeGreatsStat(stat);
  const params = new URLSearchParams({
    page: String(page),
    pageSize: String(pageSize),
  });
  if (leagueScope && leagueScope !== US_MAJOR_SCOPE) {
    params.set("leagueScope", leagueScope);
  }
  return `/nfl/all-time-greats/${config.key}?${params.toString()}`;
};
